import axios from "axios";
import { CONFIG } from "../../config";

// POST /api/auth/forget-password - existing backend endpoint, now wired up to a real
// frontend call for the first time. No userId/token is sent - only the email address.
export const forgotPasswordService = async (emailAddress) => {
	try {
		const response = await axios.post(`${CONFIG.AUTHURL}/api/auth/forget-password`, {
			email_address: emailAddress,
		});
		return response.data;
	} catch (error) {
		console.log(error);
		return { status: "unsuccessfull", message: "Something went wrong" };
	}
};
